import React, { useEffect, useState } from 'react';
import { makeStyles, AppBar, Toolbar, InputBase, Typography, IconButton, Avatar, Drawer, List, ListItem } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import MenuIcon from '@material-ui/icons/Menu';
import Logo from '../images/logo.png';
import {Link} from 'react-router-dom';


const Header = () => {
  const classes = useStyles();
  const [tablet, setTablet] = useState(true);
  const [draweropen, setDraweropen] = useState(false);

  useEffect(() => {
      const responsiveness =() => window.innerWidth < 900 ? setTablet(true) : setTablet(false);
        responsiveness();
        window.addEventListener("resize", ()=> responsiveness())
  }, []);

  const displayTablet = () => {
    const handleDrawerOpen = () => {
      setDraweropen(true);
    };

    const handleDrawerClose = () => {
      setDraweropen(false);
    };

    const headersData = ["My account", "Previous Booking", "Log Out"];

    const getDrawerChoices = () => {
      return headersData.map((data) => {
        return (
          <List>
            <ListItem>{data}</ListItem>
          </List>
        );
      });
    };

    return (
      <Toolbar className={classes.toolbar}>
        <IconButton
          {...{
            edge: "start",
            color: "default",
            "aria-label": "menu",
            "aria-haspopup": "true",
            onClick: handleDrawerOpen,
          }}
        >
          <MenuIcon fontSize="large" />
        </IconButton>
        <Drawer
          {...{
            anchor: "left",
            open: draweropen,
            onClose: handleDrawerClose,
          }}
        >
          <div>{getDrawerChoices()}</div>
        </Drawer>
        <Link to="/">
          <img src={Logo} alt="logo" className={classes.logo} />
        </Link>

        <div className={classes.right}>
          <Typography>Sign In</Typography>
          <Avatar className={classes.avatar}></Avatar>
        </div>
      </Toolbar>
    );
  };

  const displayDesktop = () => {
  return (
  <Toolbar className={classes.toolbar}>
    <Link to="/">
      <img src={Logo} alt="logo" className={classes.logo} />
    </Link>
    <div className={classes.center}>
      <InputBase
        fullWidth
        placeholder="Search here..."
        inputProps={{ className: classes.input }}
      />
      <SearchIcon style={{color: "#252525", marginRight: ".5rem"}}/>
    </div>
    <div className={classes.right}>
      <Typography>
        Sign In
      </Typography>
      <Avatar className={classes.avatar}></Avatar>
    </div>
  </Toolbar>
);
};

  
	return (
  <AppBar position="sticky" elevation={0} className={classes.root}>
    {tablet ? displayTablet() : displayDesktop()}
  </AppBar>
);
}

const useStyles = makeStyles((theme) => ({
  root: {
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: "#fafafa",
    zIndex: 99,
    borderBottom: "1px solid #ccc",
  },
  toolbar:{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }, 
  logo: {
  	width: "100px",
    height: "auto",
    margin: theme.spacing(1,0,0,2),
  	cursor: "pointer",
    objectFit: "contain",
  },
  input: {
    fontSize: "1.2rem",
    padding: theme.spacing(1,5,1,5),
  },
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: "1px solid lightgray",
    minWidth: "300px",
    borderRadius: "999px",
    padding: theme.spacing(1),
    margin: theme.spacing(1),

  },
  right: {
    display: "flex",
    alignItems: "center",
    color: "#333",
    marginLeft: theme.spacing(2),
  },
  avatar: {
    marginLeft: theme.spacing(1),
  }
}));

export default Header